import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EducationalQualificationsFormComponent } from './educational-qualifications-form/educational-qualifications-form.component';
import { MatDialog } from '@angular/material/dialog';
import { AmbassadorsProfileService } from 'src/app/services/ambassadors-profile.service';
import { AmbassadorEducationalQualification } from 'src/app/models/user/AmbassadorEducationalQualification';
import { LookupsService } from 'src/app/services/lookups.service';
import { Lookup } from 'src/app/models/lookups/Lookup';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-educational-qualifications',
  standalone: false,
  templateUrl: './educational-qualifications.component.html'
})
export class EducationalQualificationsComponent implements OnInit {
  @Input() userId!:any;
  @Input() canModify!: boolean;
  formGroup!: FormGroup;
  showModal = false
  dataLoading = false
  dataSource: AmbassadorEducationalQualification[] = []

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private service: AmbassadorsProfileService,
    private lookupsService: LookupsService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.getAll()
  }


  getAll() {
    this.dataLoading = true;
    const params = this.userId ? { userId: this.userId } : {};
    this.service.GetAmbassadorEducationalQualification(params).subscribe((response: any) => {
      this.dataLoading = false;
      this.dataSource = response as AmbassadorEducationalQualification[];
    }, err => {
      this.dataLoading = false
    })
  }



  openForm(record: any = null) {
    const dialogRef = this.dialog.open(EducationalQualificationsFormComponent, {
      width: '550px',
      data: { record },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getAll();
      }
    });

  }





  deleteRecord(id: number) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousure'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.service.DeleteAmbassadorEducationalQualification(id).subscribe(
          (data: any) => {
            Swal.fire({
              title: this.translate.instant('swalMsg.deletededsuccessfuly'),
              icon: 'success',
              confirmButtonText: this.translate.instant('swalMsg.ok')
            });
            this.getAll();
          }, (error: any) => {
            console.error(error);
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: this.translate.instant('swalMsg.FailedText'),
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.ok')
            });
          });
      }
    });
  }


}
